module.exports = __webpack_public_path__ + "img/GetBoarded_Logo.8afd8f7f.svg";